import { useEffect, useState } from "react"
import { gsap } from "gsap"
import Button from "@hfc/shared/components/Button"

const useZoomButtons = (shouldHideOverlay, currentPath) => {
	if (shouldHideOverlay) return { zoom: 1, render: null }
	const [zoom, setZoom] = useState<number>(1)

	const triggerZoomAnimation = () => {
		const id = "room"
		const element = document.getElementById(id)
		let tween: gsap.core.Tween

		if (element) {
			tween = gsap.to(`#${id}`, 0.3, {
				scale: zoom,
				x: 0,
				y: 0,
				transformOrigin: "center 20%",
			})
		}

		return () => {
			if (tween) tween.kill()
		}
	}

	const clickZoom = (type: string) => {
		const zoomIndex = 0.5
		let scale = zoom
		switch (type) {
			case "in":
				scale = zoom + zoomIndex
				break
			case "out":
				scale = zoom - zoomIndex
				break
			case "center":
			default:
				triggerZoomAnimation()
				break
		}

		setZoom(scale)
	}

	useEffect(() => {
		setZoom(1)
		gsap.to(`#room`, 0, {
			scale: 1,
			x: 0,
			y: 0,
			transformOrigin: "center 20%",
		})
	}, [currentPath])

	useEffect(() => {
		triggerZoomAnimation()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [zoom])

	return {
		zoom,
		render: (
			<div className="fixed bottom-0 right-0 z-40 grid grid-cols-1 gap-4 m-20 md:grid-cols-3 fixed-overlay">
				<Button
					className="px-6 py-2"
					onClick={() => clickZoom("center")}
					variant={"secondary"}
				>
					↔
				</Button>
				<Button
					className="px-6 py-2"
					onClick={() => clickZoom("out")}
					variant={zoom > 0.5 ? "secondary" : "grey"}
					disabled={zoom <= 0.5}
				>
					-
				</Button>
				<Button
					className="px-6 py-2"
					onClick={() => clickZoom("in")}
					variant={zoom < 1.5 ? "secondary" : "grey"}
					disabled={zoom >= 1.5}
				>
					+
				</Button>
			</div>
		),
	}
}

export default useZoomButtons
